import { TFunction } from "react-i18next";
import { Item, ObjectGeneric } from "../../../../../utils/types/generals";

export const handleErrors = (data: ObjectGeneric, t: TFunction<"translation", undefined>) => {
    let error: ObjectGeneric = {}

    if (data?.digitalFenceMts !== null && !data?.digitalFenceMts) {
        error.digitalFenceMts = t('general.validations.required')
    }

    if (typeof data?.locale !== 'string' && data?.locale !== null && data?.locale?.type !== 'application/json') {
        error.locale = t('general.validations.wrongFile')
    }

    return error
}

export const fotmatData = ({ name, value, body, timeList }: { name: string; value: unknown; body: ObjectGeneric; timeList:Item[]  }) => {
    if (name.includes('img_')) {
        const newName = name.replace('img_', '')

        return { ...body, img: { ...body.img, [newName]: value, }, }
    }
    if (name == 'timeout' && !value) {
        return {...body, timeout: timeList[0]}
    }
    if (name === 'gpsActive') {
        if (!body.digitalFence && !body.gpsRequired) {
            return { ...body, [name]: value, }
        }
        return body
    }
    if (name === 'gpsRequired') {
        if (!body.digitalFence) {
            return { ...body, gpsActive: value ? true : body.gpsActive, [name]: value, }
        }
        return body
    }
    if (name === 'digitalFence') {
        if (value) {
            return {
                ...body,
                gpsActive: true,
                gpsRequired: true,
                [name]: value,
            }
        }
    }
    return {  ...body, [name]: value, }
}
